import type { FetchValuationArgs } from './api';
import type { WidgetData, WidgetOptionalData } from './types';

export function mapObjectCategory(
  property: WidgetData['property'],
): FetchValuationArgs['object_category'] {
  return (
    {
      Kauf_Haus: 'HOUSE',
      Kauf_Wohnung: 'APARTMENT',
    } as const
  )[property];
}

export function mapInterioirQuality(
  qualityStandard: WidgetOptionalData['qualityStandard'],
): FetchValuationArgs['interior_quality'] {
  return (
    {
      Simple: 'SIMPLE',
      Normal: 'NORMAL',
      Sophisticated: 'HIGH_GRADE',
    } as const
  )[qualityStandard];
}

export function mapObjectType(
  propertyType: WidgetOptionalData['propertyType'],
): FetchValuationArgs['object_type'] {
  return (
    {
      'Einfamilienhaus / Villa': 'ONE_TWO_FAMILY_HOUSE',
      'WOHN- UND GESCHÄFTSGEBÄUDE': 'MIXED_USAGE_BUILDING',
      Apartment: 'REGULAR_APARTMENT',
      Penthouse: 'PENTHOUSE',
      'Ground floor': 'REGULAR_APARTMENT',
      'Doppelhaushälfte / Reihenhaus': 'SEMI_DETACHED_HOUSE',
    } as const
  )[propertyType];
}

export function mapInvestmentRentActive(
  propertyRented: WidgetOptionalData['propertyRented'],
): FetchValuationArgs['investment_rent_active'] {
  return ['partially rented', 'fully rented'].includes(propertyRented);
}
